import axios from 'axios';
import { secureStorage } from './utils/secureStorage';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Wichtig für Cookies
});

// Request interceptor to add auth token (als Fallback für Cookie-Authentifizierung)
API.interceptors.request.use(
  (config) => {
    // Prüfe verschlüsselten Token als Fallback
    const token = secureStorage.getToken();
    if (token && secureStorage.isTokenValid(token)) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Sichere Löschung aller Auth-Daten
      secureStorage.clearToken();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth endpoints
export const login = (credentials) => API.post('/auth/login', credentials);
export const register = (userData) => API.post('/auth/register', userData);
export const logout = () => API.post('/auth/logout');
export const updateAvatar = (avatarData) => API.put('/auth/avatar', avatarData);

// Economics Quiz endpoints
export const getEconomicsQuestions = (moduleSlug) => API.get(`/economics-quiz/questions/${moduleSlug}`);
export const submitEconomicsAnswers = (data) => API.post('/economics-quiz/submit', data);

// Technical Quiz endpoints
export const getTechnicalQuestions = (moduleSlug) => API.get(`/technical-quiz/questions/${moduleSlug}`);
export const submitTechnicalAnswers = (data) => API.post('/technical-quiz/submit', data);

// SQL Quiz endpoints
export const getSqlQuestions = () => API.get('/sql-quiz/questions');
export const executeSqlQuery = (data) => API.post('/sql-quiz/execute', data);
export const submitSqlQuiz = (data) => API.post('/sql-quiz/submit', data);

// Legacy endpoints (for backward compatibility)
export const getQuestionsByModule = (moduleSlug) => {
  // Route to appropriate endpoint based on module type
  if (moduleSlug === 'wirtschaft') {
    return getEconomicsQuestions(moduleSlug);
  } else {
    return getTechnicalQuestions(moduleSlug);
  }
};

export const submitQuizAnswers = (data) => {
  // This will be handled by the specific components
  console.warn('submitQuizAnswers is deprecated. Use submitEconomicsAnswers or submitTechnicalAnswers instead.');
  return Promise.reject(new Error('Use specific submit functions'));
};

export const getAllQuestionsByCategories = () => API.get('/economics-quiz/categories');

export const getLearningTopics = (moduleId) =>
  API.get(`/learning/${moduleId}/topics`);

export const getLearningTopicsBySlug = (moduleSlug) =>
  API.get(`/learning/by-slug/${moduleSlug}/topics`);

export default API;